import { render, staticRenderFns } from "./imageUploader.vue?vue&type=template&id=50570d90"
import script from "./imageUploader.vue?vue&type=script&lang=js"
export * from "./imageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports